import React, { useEffect, useState } from "react";
import { FilterIconBlack, SearchIconBlack } from "../../constant/imagePath";
import { Input } from "../Input/Input";
import classes from "./InputWithSearchIcon.module.css";
import PropTypes from "prop-types";
import { ReactSVG } from "react-svg";
import useDebounce from "../../CustomHooks/useDebounce";

export const InputWithSearchIcon = ({
  state,
  setter,
  placeholder = "Search here",
  isShowFilter,
  onFilter,
  type = "text",
  icon = SearchIconBlack,
  searchArray,
  showSearchResults,
  renderSearchTitle,
}) => {
  const [searchFocus, setSearchFoucs] = useState(false);
  const debouncedSearch = useDebounce(state, 500);

  useEffect(
    () => {
      if (debouncedSearch) {
        setSearchFoucs(true);
      }
    },
    [debouncedSearch] // Only call effect if debounced search term changes
  );

  return (
    <div className={classes.inputWithSearch}>
      <Input
        state={state}
        setter={setter}
        type={type}
        placeholder={placeholder}
        inputStyle={{
          paddingLeft: "48px",
          paddingRight: isShowFilter ? "48px" : "12px",
        }}
      />
      <ReactSVG src={icon} className={classes.icon} />
      {isShowFilter && (
        <ReactSVG
          src={FilterIconBlack}
          className={classes.filterIcon}
          onClick={onFilter}
        />
      )}

      {/* Search  */}
      {searchFocus && showSearchResults && (
        <div className={[classes.searchOverlayContainer].join(" ")}>
          {searchArray?.map((item, index) => (
            <span
              onClick={() => {
                setter(renderSearchTitle(item));
                setTimeout(() => {
                  setSearchFoucs(false);
                }, 50);
              }}
            >
              {renderSearchTitle(item)}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

InputWithSearchIcon.propTypes = {
  state: PropTypes.string,
  setter: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  onFilter: PropTypes.func,
  icon: PropTypes.string,
};
InputWithSearchIcon.defaultProps = {
  placeholder: "Search",
  type: "text",
  icon: SearchIconBlack,
};
